export function assertDefined(value, message) {
    if (value === undefined) {
        throw new Error(message);
    }
}
//# sourceMappingURL=assertDefined.js.map